(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-recommended-products';
  var CONTAINER_SELECTOR = '.oddit-section-recommended-products__container';
  var GRID_SELECTOR = '.oddit-section-recommended-products__grid';
  var PRODUCT_SELECTOR = '.oddit-section-recommended-products__product';

  function bindCardHandlers(section) {
    if (section.dataset.oddiCardHandlersBound === 'true') return;
    section.dataset.oddiCardHandlersBound = 'true';

    section.addEventListener('click', function (e) {
      var thumb = e.target.closest('.oddit-section-recommended-products__variant-thumb');
      if (!thumb) return;
      var group = thumb.closest('.oddit-section-recommended-products__variant-thumbs');
      if (!group) return;
      e.preventDefault();
      e.stopPropagation();
      group
        .querySelectorAll('.oddit-section-recommended-products__variant-thumb--selected')
        .forEach(function (t) {
          t.classList.remove('oddit-section-recommended-products__variant-thumb--selected');
        });
      thumb.classList.add('oddit-section-recommended-products__variant-thumb--selected');

      var card = thumb.closest(PRODUCT_SELECTOR);
      if (!card) return;

      var swatchImage = thumb.getAttribute('data-swatch-image');
      if (swatchImage) {
        var img = card.querySelector('.oddit-section-recommended-products__product-image');
        if (img) {
          img.src = swatchImage;
          var swatchSrcset = thumb.getAttribute('data-swatch-srcset');
          if (swatchSrcset) img.srcset = swatchSrcset;
        }
      }

      var slideIndex = thumb.getAttribute('data-swatch-slide-index');
      if (slideIndex !== null) {
        var bg = card.querySelector('[data-gallery]');
        if (bg) setGalleryIndex(bg, parseInt(slideIndex, 10));
      }
    });

    section.addEventListener('click', function (e) {
      if (e.target.closest('.gw-add-to-wishlist-product-card-placeholder')) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    section.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-gallery-prev], [data-gallery-next]');
      if (!nav) return;
      e.preventDefault();
      e.stopPropagation();
      var card = nav.closest(PRODUCT_SELECTOR);
      if (!card) return;
      var bg = card.querySelector('[data-gallery]');
      if (!bg) return;
      var current = parseInt(bg.getAttribute('data-gallery-index'), 10) || 0;
      var delta = nav.hasAttribute('data-gallery-prev') ? -1 : 1;
      setGalleryIndex(bg, current + delta);
    });

    var galleryHoverEnabled = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    if (galleryHoverEnabled) {
      section.addEventListener('mouseover', function (e) {
        var card = e.target.closest(PRODUCT_SELECTOR);
        if (!card) return;
        if (e.relatedTarget && card.contains(e.relatedTarget)) return;
        var bg = card.querySelector('[data-gallery]');
        if (!bg) return;
        var current = parseInt(bg.getAttribute('data-gallery-index'), 10) || 0;
        if (current === 0) setGalleryIndex(bg, 1);
      });

      section.addEventListener('mouseout', function (e) {
        var card = e.target.closest(PRODUCT_SELECTOR);
        if (!card) return;
        if (e.relatedTarget && card.contains(e.relatedTarget)) return;
        var bg = card.querySelector('[data-gallery]');
        if (!bg) return;
        setGalleryIndex(bg, 0);
      });
    }
  }

  function hydrateGallery(bg) {
    if (bg.getAttribute('data-gallery-hydrated') === 'true') return;
    bg.setAttribute('data-gallery-hydrated', 'true');
    var json = bg.getAttribute('data-gallery-images');
    if (!json) return;
    var images;
    try {
      images = JSON.parse(json);
    } catch (err) {
      return;
    }
    if (!Array.isArray(images) || images.length === 0) return;
    var sizes = bg.getAttribute('data-gallery-sizes') || '';
    var existingByIndex = {};
    var existingSlides = bg.querySelectorAll('[data-slide-index]');
    for (var k = 0; k < existingSlides.length; k++) {
      var ix = parseInt(existingSlides[k].getAttribute('data-slide-index'), 10);
      if (!isNaN(ix)) existingByIndex[ix] = true;
    }
    var frag = document.createDocumentFragment();
    for (var i = 0; i < images.length; i++) {
      if (existingByIndex[i]) continue;
      var slide = document.createElement('div');
      slide.className = 'oddit-section-recommended-products__hover-slide';
      slide.setAttribute('data-slide-index', String(i));
      var imgEl = document.createElement('img');
      imgEl.className = 'oddit-section-recommended-products__product-hover-image';
      imgEl.alt = '';
      imgEl.loading = 'lazy';
      imgEl.setAttribute('fetchpriority', 'low');
      if (sizes) imgEl.sizes = sizes;
      if (images[i].srcset) imgEl.srcset = images[i].srcset;
      imgEl.src = images[i].src;
      slide.appendChild(imgEl);
      frag.appendChild(slide);
    }
    bg.appendChild(frag);
  }

  function setGalleryIndex(bg, rawIndex) {
    hydrateGallery(bg);
    var count = parseInt(bg.getAttribute('data-gallery-count'), 10);
    if (!count || count < 1) return;
    var idx = ((rawIndex % count) + count) % count;
    bg.setAttribute('data-gallery-index', String(idx));
    var slides = bg.querySelectorAll('[data-slide-index]');
    for (var i = 0; i < slides.length; i++) {
      var sIdx = parseInt(slides[i].getAttribute('data-slide-index'), 10);
      slides[i].classList.toggle(
        'oddit-section-recommended-products__hover-slide--active',
        sIdx === idx
      );
    }
    var card = bg.closest(PRODUCT_SELECTOR);
    if (card) {
      var dots = card.querySelectorAll('[data-gallery-dot]');
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle(
          'oddit-section-recommended-products__dot--active',
          j === idx
        );
      }
    }
  }

  function loadRecommendations(section) {
    if (section.dataset.oddiRecsLoaded === 'true') return;
    section.dataset.oddiRecsLoaded = 'true';

    var baseUrl = section.dataset.recommendationsUrl;
    var sectionId = section.id;
    var productId = section.dataset.productId;
    var limit = section.dataset.recommendationsLimit || '4';
    var intent = section.dataset.recommendationsIntent || 'related';

    if (!baseUrl || !sectionId || !productId) return;

    var params = new URLSearchParams({
      section_id: sectionId,
      product_id: productId,
      limit: limit,
      intent: intent,
    });

    fetch(baseUrl + '?' + params.toString())
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Recommendations request failed: ' + response.status);
        }
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContainer = doc.querySelector(CONTAINER_SELECTOR);
        var existingContainer = section.querySelector(CONTAINER_SELECTOR);
        var hasProducts =
          newContainer &&
          newContainer.querySelector(
            GRID_SELECTOR + ':not(.oddit-section-recommended-products__grid--skeleton)'
          );

        if (hasProducts && existingContainer) {
          existingContainer.innerHTML = newContainer.innerHTML;
          section.removeAttribute('aria-busy');
        } else {
          section.hidden = true;
        }
      })
      .catch(function (error) {
        console.error('[oddit-section-recommended-products]', error);
        section.hidden = true;
      });
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      bindCardHandlers(section);
      loadRecommendations(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
